export default {"src":"/_next/static/media/poe.9a6d7868.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};